export const FIRST_OWNER = 'primer titular';
